/* eslint-disable @typescript-eslint/no-unused-vars */
const terraformEnvironment: string = 'prod';
export default terraformEnvironment;
